import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface TriangleDownProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const TriangleDown = ({ fill, title, height, width, ...rest }: TriangleDownProps) => (
    <SVGBase viewBox="0 40 430 330" height={height} width={width} title={title} fill={fill} {...rest}>
        <polygon
            fill={fill}
            transform="translate(215.000000, 165.000000) rotate(-180.000000) translate(-215.000000, -165.000000)"
            points="215 0 430 330 2.28865538e-13 330"
        />
    </SVGBase>
);

export default TriangleDown;
